import CloseOutlined from '@mui/icons-material/CloseOutlined';
import styles from './NextStepCard.module.css';

export interface NextStepCardProps {
	title: string;
	subtitle: string;
	description: string;
	secondaryLabel: string;
	primaryLabel: string;
	onSecondary: () => void;
	onPrimary: () => void;
}

export const NextStepCard = ({
	title,
	subtitle,
	description,
	secondaryLabel,
	primaryLabel,
	onSecondary,
	onPrimary,
}: NextStepCardProps) => (
	<div className={styles.card}>
		<div className={styles.header}>
			<div className={styles.headerText}>
				<h3 className={styles.title}>{title}</h3>
				<span className={styles.subtitle}>{subtitle}</span>
			</div>
			<button
				type="button"
				className={styles.closeButton}
				onClick={onSecondary}
				aria-label="Fechar"
			>
				<CloseOutlined className={styles.closeIcon} />
			</button>
		</div>
		<p className={styles.description}>{description}</p>
		<div className={styles.actions}>
			<button type="button" className={styles.secondaryButton} onClick={onSecondary}>
				{secondaryLabel}
			</button>
			<button type="button" className={styles.primaryButton} onClick={onPrimary}>
				{primaryLabel}
			</button>
		</div>
	</div>
);
